function addNoindexFollow() {
    const existingMeta = document.querySelector('meta[name="robots"]');
    if (existingMeta && existingMeta.content.includes('noindex, follow')) {
        return;
    }
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, follow';
    document.head.appendChild(meta);
}

function removeNoindexFollow() {
    const existingMeta = document.querySelector('meta[name="robots"]');
    if (existingMeta && existingMeta.content.includes('noindex, follow')) {
        existingMeta.remove();
    }
}

function addOrRemoveNoindexFollow(url) {
    const urlObj = new URL(url, window.location.origin);
    const hasPage = urlObj.searchParams.has('page');
    const view = urlObj.searchParams.get('view');
    const rootPath = urlObj.pathname.split('/')[1] || '';
    switch (rootPath) {
        case 'search':
            // never index search results
            addNoindexFollow();
            break;
        case 'collections':
            // only index collections if on default view (no page parameter) and not viewing all products (view parameter is not 'all')
            if (!hasPage && view !== 'all') {
                removeNoindexFollow();
            } else {
                addNoindexFollow();
            }
            break;
        default:
            // index all other pages
            removeNoindexFollow();
            break;
    }
}

function setupSeo() {
    window.addEventListener('popstate', (...args) => {
        addOrRemoveNoindexFollow(window.location.href);
    });
    // Source - https://stackoverflow.com/a/64927639
    // Posted by Kalanj Djordje Djordje, modified by community. See post 'Timeline' for change history
    // Retrieved 2026-06-18, License - CC BY-SA 4.0

    window.history.pushState = new Proxy(window.history.pushState, {
        apply: (target, thisArg, argArray) => {
            addOrRemoveNoindexFollow(argArray[2]);
            return target.apply(thisArg, argArray);
        },
    });
}

setupSeo();